import React from 'react';
// import SafeAreaView from 'react-native-safe-area-view';
import {useTheme} from '../../theme';
import {Platform, StatusBar, View} from 'react-native';
import {useSelector} from 'react-redux';
import {desktopMenuHeight, DeviceSize, maxDesktopContentWidth, useDeviceSize} from '../../theme/helpers';
import {holderProfileSelector, profileTokenSelector} from '../../../redux/selectors/profile';
import KeyboardHandleWrapper from '../keyboardHandleWrapper';
import {Footer} from '../footer';
import {useStyles} from '../../hooks/styles';
import {CustomScrollView} from '../scrollView';
import {cardBlockedNotificationHeight} from '../cardBlockedNotification';
import {Props} from './model';
import {useDimensions} from '../../hooks/useDimensions';
import {esiaUserHasNoCardsSelector} from '../../../redux/selectors/login';
import {CardStatus} from '../../../types/enums/cardStatus';

const Screen: React.FC<Props> = ({hideFooter, children, style, fullWidth, scrollViewRef}) => {
  const theme = useTheme();
  const deviceSize = useDeviceSize();
  const token = useSelector(profileTokenSelector());
  const {height} = useDimensions();
  const userHasNoCards = useSelector(esiaUserHasNoCardsSelector);

  const holderProfile = useSelector(holderProfileSelector());
  const cardIsBlocked = Boolean(holderProfile?.uscIsBlocked) || holderProfile?.cardStatusId === CardStatus.Blocked;

  const styles = useStyles(({mediaOnly}) => ({
    container: {
      ...mediaOnly(DeviceSize.desktop, {
        paddingTop: desktopMenuHeight,
      }),
      display: 'flex',
      alignItems: 'center',
      flex: 1,
      position: 'relative',
      zIndex: 1,
    },
    tokenExistContainer: {
      maxWidth: maxDesktopContentWidth,
    },
    content: {width: '100%', alignSelf: 'center', flexGrow: 1, flexShrink: 0, position: 'relative', zIndex: 1},
    scrollView: {
      width: '100%',
      flex: 1,
      flexBasis: Platform.OS === 'web' && deviceSize !== DeviceSize.desktop ? height - 54 : 'auto',
    },
    scrollContent: {
      width: '100%',
      flex: 1,
      height: Platform.OS === 'web' ? 'auto' : height,
      paddingTop:
        holderProfile?.cardStatusId &&
        (Platform.OS !== 'web' || deviceSize === DeviceSize.desktop) &&
        (userHasNoCards || cardIsBlocked)
          ? cardBlockedNotificationHeight
          : 0,
    },
  }));

  const content = (
    <View style={[styles.container, theme.screen.container[deviceSize], style]}>
      <StatusBar />
      <CustomScrollView
        bounces={false}
        withRefresh={false}
        style={styles.scrollView}
        contentContainerStyle={styles.scrollContent}
        ref={scrollViewRef}>
        <View style={[styles.content, token && !fullWidth ? styles.tokenExistContainer : null]}>{children}</View>
        {!hideFooter && Platform.OS === 'web' ? <Footer /> : null}
      </CustomScrollView>
    </View>
  );
  return Platform.OS === 'web' ? content : <KeyboardHandleWrapper>{content}</KeyboardHandleWrapper>;
};

export default Screen;
